import { fetch } from '@utils/utils';
import * as T from '@modules/repairs/_repairsTypes';

const getRepair = ({ addError }) => async (id: string): Promise<T.Repair> => {
  try {
    const response: any = await fetch(`/metropolis/api/cl/repair/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Repair = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

const putRepair = async (body: any): Promise<boolean> => {
  try {
    const response: any = await fetch(`/metropolis/api/cl/repair/${body.id}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });

    return response.ok;
  } catch (err) {
    return false;
  }
};

export { getRepair, putRepair };



// WEBPACK FOOTER //
// ./src/modules/repairs/_repairsActions.ts